/* eslint-disable no-param-reassign */
import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { UserNotification } from '../types/local';
import type { RouterOutput } from '../utils/trcp';

interface Props {
	featureFlags: RouterOutput['user']['getUserFeatureFlags'];
	setFeatureFlags: (ff: RouterOutput['user']['getUserFeatureFlags']) => void;
	//
	notifications: UserNotification[];
	setNotifications: (notifications: UserNotification[]) => void;
	readNotification: (id: string) => void;
	//
	schools: RouterOutput['user']['getUserSchools'];
	setSchools: (schools: RouterOutput['user']['getUserSchools']) => void;
	//
	groupUserSettings?: RouterOutput['user']['getGroupUserSettings'];
	setGroupUserSettings: (groupUserSettings: RouterOutput['user']['getGroupUserSettings']) => void;

	//
	isGroupBlocked?: boolean;
	setIsGroupBlocked: (isGroupBlocked: boolean) => void;

	//
	groupSettings?: RouterOutput['user']['getGroupSettings'];
	setGroupSettings: (groupSettings: RouterOutput['user']['getGroupSettings']) => void;
}

export const useUserStore: UseBoundStore<StoreApi<Props>> = create(
	immer<Props>(set => ({
		featureFlags: {},
		setFeatureFlags: (ff: RouterOutput['user']['getUserFeatureFlags']) => {
			set(state => {
				state.featureFlags = ff;
			});
		},
		//
		notifications: [],
		setNotifications: notifications => set({ notifications }),
		readNotification: id =>
			set(state => {
				state.notifications = state.notifications.filter(n => n.id !== id);
			}),
		//
		schools: [],
		setSchools: schools => set({ schools }),
		//
		groupUserSettings: undefined,
		setGroupUserSettings: groupUserSettings => set({ groupUserSettings }),
		//
		isGroupBlocked: undefined,
		setIsGroupBlocked: isGroupBlocked => set({ isGroupBlocked }),
		//
		groupSettings: undefined,
		setGroupSettings: groupSettings => set({ groupSettings }),
	})),
);
